import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUser, signInSubmit } from '../../redux/features/auth/authService';
import styles from './index.module.css';
import LogoImage from '../../assets/images/brand/Uni_logo_landscape.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import BeatLoader from "react-spinners/BeatLoader";

const Login = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [errors, setErrors] = useState({ email: '', password: '' });
  const [errorMsg, setErrorMsg] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isSignInLoading, signInMessage, isSignedIn } = useSelector((state) => state.auth.signInDetails);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateLogin = () => {
    const errors = {};
    if (!credentials.email) {
      errors.email = 'Email is required!'
    } else if (!isValidEmail(credentials.email)) {
      errors.email = 'Invalid email address!';
    }
    if (!credentials.password) {
      errors.password = 'Password is required!'
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    } else {
      return true;
    }
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setErrorMsg(null);
      if (validateLogin()) {
        const result = await dispatch(signInSubmit(credentials)).unwrap();
        if (result.success) {
          const result = await dispatch(getUser()).unwrap();
          if (result.role.name === 'admin') {
            navigate('/admin/certificates');
          } else if (result.role.name === 'exam_controller') {
            navigate('/controller/certificates');
          } else if (result.role.name === 'exam_controller_assistant') {
            navigate('/assistant/certificates');
          } else if (result.role.name === 'user') {
            navigate('/user/certificates');
          } 
        } else {
          setErrorMsg('Login failed:');
        }
      }
    } catch (error) {
      setErrorMsg(error.message);
    }
  };

  return (
    <div className={styles.content}>
      <div className={styles.cardSection}>
        <div className={styles.logoSection}>
          <img src={LogoImage} alt='logo' className={styles.logoImg} />
        </div>
        <div className={styles.formContainer}>
          <form onSubmit={handleLogin} className={styles.loginForm}>
            <div className={`input-group`}>
              <div>
                <label className={`form-label`}>Email</label>
              </div>
              <input
                type="text"
                placeholder="johndoe@gmail.com"
                value={credentials.email}
                onChange={(e) => {
                  setCredentials({ ...credentials, email: e.target.value });
                  setErrors({ ...errors, email: '' })
                }}
                className={`${styles.loginInput} primary-input`}
              />
            </div>
            {errors.email && (
              <p className={`${styles.errorMsg} text-danger`}>{errors.email}</p>
            )}
            <div className={`input-group`}>
              <div>
                <label className={`form-label`}>Password</label>
              </div>
              <input
                type={passwordVisible ? "text" : "password"}
                placeholder="********************"
                value={credentials.password}
                onChange={(e) => {
                  setCredentials({ ...credentials, password: e.target.value });
                  setErrors({ ...errors, password: '' })
                }}
                className={`${styles.loginInput} primary-input`}
              />
              {!passwordVisible ?
                <FontAwesomeIcon icon={faEyeSlash} style={{ marginLeft: '-40px' }} onClick={() => setPasswordVisible(true)} /> :
                <FontAwesomeIcon icon={faEye} style={{ marginLeft: '-40px' }} onClick={() => setPasswordVisible(false)} />}
            </div>
            {errors.password && (
              <p className={`${styles.errorMsg} text-danger`}>{errors.password}</p>
            )}
            {!isSignedIn && (
              <p className={`error-response`}>{signInMessage?.message}</p>
            )}
            <button type="submit" className={styles.loginBtn}>
              {isSignInLoading ? <BeatLoader color='#ffffff' /> : `Login`}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
